module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ez4OB"))).then(() => parcelRequire('hEqeo'));